import HealthCoverage from '@/modules/health/common/models/MID/HealthCoverage'

export default class HealthRaterPriceInsuredToSave {
  /** (String): Código postal del asegurado. */
  postalCode!: string

  /** (DateTime): Fecha de nacimiento del asegurado. */
  birthDate!: string

  /** (Integer): Orden del asegurado. */
  riskNumber!: string

  /** (Coverage): Coberturas contratadas para el asegurado */
  optionalCoverage: HealthCoverage[] | undefined

  constructor(data: HealthRaterPriceInsuredToSave) {
    this.postalCode = data.postalCode
    this.birthDate = data.birthDate
    this.riskNumber = data.riskNumber

    this.optionalCoverage =
      data.optionalCoverage?.map(
        (c) =>
          new HealthCoverage({
            coverageCode: c.coverageCode,
            sumInsured: c.sumInsured
          })
      ) ?? undefined
  }
}
